import {Text2SpeachParams} from '@/store/AIAvatar/aiavatarGenerationModel';
import ssmlCheck, {ISSMLCheckError, ISSMLCheckOptions} from 'ssml-check';
import {i18n} from '@/utils/i18nUtils'; // Import the i18n instance

export const checkValidSSML = async (innerText: string): Promise<ISSMLCheckError[]> => {
  // We can't put a full ssml here because the voice and prosody are systematically reported as errors, even if we
  // force the platform as "amazon" in the options (there is no microsoft option here)
  const ssml = '<speak version="1.0" xmlns="https://www.w3.org/2001/10/synthesis" xml:lang="en-US" >\n' +
      //'<voice name="' + ssmlContent.voice + '">\n' +
      //'<prosody rate="0%">' +
      //'<lang xml:lang="' + ssmlContent.lang + '">' +
      innerText +
      //'</lang>' +
      //'</prosody>\n' +
      //'</voice>\n' +
      '</speak>';

  // available options:
  //   platform:all,             // The voice platform to evaluate this SSML against.
  //                              // Valid values are "all", "amazon", or "google".
  //   locale:undefined,          // The locale you want to check against, used for certain
  //                              // locale-specific attributes like amazon:emotion
  //   validateAudioFiles:false,  // Whether to validate audio files against
  //                              // acceptable formats (bit rate, sample rate, etc)
  //   getPositions:false,        // If set, the index of the tag will be returned as the position
  //                              // field within the error object
  //   unsupportedTags:undefined, // An array of tags that will be flagged as invalid
  //                              // For example, ['prosody']
  const options: ISSMLCheckOptions = {
    platform: "google"
  }

  const errors = await ssmlCheck.check(ssml, options);
  if (errors) {
    console.warn("Errors in the SSML: ", JSON.stringify(errors));
    return errors;
  }
  return [];
}

export const generateErrorMessages = (errors: ISSMLCheckError[]): string => {
  // Format SSML errors into a readable string message
  return errors.map(error => {
    let message =  `${i18n.t('aiAvatar.content.ssmlErrors').toString()} ${error.type}`;
    if (error.type === "tag") {
      if ('tag' in error) message += ` "${error.tag}"`;
      if ('attribute' in error) message += `, attribute "${error.attribute}"`;
      if ('value' in error) message += `, value "${error.value}"`;
    }
    return message;
  }).join('\n');
}